import SwatchesSkeleton from 'components/ItemSubstitution/SwatchesSkeleton/SwatchesSkeleton';

export default SwatchesSkeleton;
